<template>
  <div class="tw-w-96 lg:tw-w-1/3 tw-mx-8 tw-mb-16 lg:tw-mb-0">
    <div :class="['tw-w-full tw-h-96 tw-mb-12 tw-rounded-full tw-flex tw-items-center tw-justify-center', {'tw-bg-orange-medium': props.active, 'tw-bg-gray-300': !props.active }]">
      <Icon height="132" width="132" :type="props.iconType!" class="tw-inline-block"/>
    </div>
    <div class="text-center tw-my-4">
      <span class="tw-text-3xl tw-font-black tw-uppercase">{{props.hungerLevel}}</span>&nbsp;
      <sup v-if="false"><span class="fa fa-info-circle tw-text"></span></sup>
    </div>
    <div class="flex" v-if="requiresAmount">
      <input 
        :value="props.amount"
        @change="updateAmount"
        @keyup="updateAmount"
        type="text"
        class="tw-block tw-mx-auto tw-text-center tw-py-4 tw-w-32 tw-font-bold tw-appearance-none focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-bg-transparent tw-text-2xl">
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '../../components/Icon.vue'

const emit = defineEmits(['amountChanged'])

const props = defineProps({
  hungerLevel: String,
  hungerLevelDetails: String,
  requiresAmount: Boolean,
  image: String,
  iconType: String,
  amount: Number,
  active: Boolean,
  max: Number,
})

const updateAmount = (event: Event) => {
  const target = event.target as HTMLButtonElement;
  if (target) {
    let val = parseFloat(target.value);
    if (isNaN(val)) {
      target.value = "0";
      val = 0;
    } 
    // If we support a max amount
    // else {
    //   if (val > props.max!) {
    //     val = props.max!;
    //     target.value = val.toString();
    //   } else if (val < 0) {
    //     val = 0;
    //     target.value = val.toString();
    //   }
    // }
    emit('amountChanged', val);
  }
}

</script>